const DEFAULT_DATA_LABEL_CONFIG = {
  enabled: false,
};

export default class DataLabelsConfigBuilder {
  #config = { ...DEFAULT_DATA_LABEL_CONFIG };

  build() {
    return this.#config;
  }
}
